const NAME = 'local-lang';

export default {
    get() {
        return localStorage.getItem(NAME) || process.env.VUE_APP_DEFAULT_LANG
    },
    set(token) {
        localStorage.setItem(NAME, token)
    },
    clear() {
        this.set('')
    }
}
